export interface WidgetTitleMeta {
    isCustom: boolean;
    tailPrefix: string;
    tailKey: string;
    tail: string;
}

export const EMPTY_WIDGET_TITLE_META: WidgetTitleMeta = { isCustom: false, tailPrefix: '', tailKey: '', tail: '' };
